module.exports = __webpack_public_path__ + "img/2.54a52d62.png";